import {
  SET_MATCHED_PHOTO_BACKGROUND,
  RESET_MATCHED_PHOTO_BACKGROUNDS,
} from '../actions/matched-photos';

const initialState = {
  printBackgrounds: {},
};

const matchedPhotosReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_MATCHED_PHOTO_BACKGROUND: {
      return {
        ...state,
        printBackgrounds: {
          ...state.printBackgrounds,
          [action.matchedPhotoId]: action.printBackgroundId,
        },
      };
    }

    case RESET_MATCHED_PHOTO_BACKGROUNDS:
      return {
        ...state,
        printBackgrounds: {},
      };

    default:
      return state;
  }
};

export { initialState };
export default matchedPhotosReducer;
